"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalization = exports.useLocalizationLocale = exports.useLocalizationMessages = exports.useLocalizationContext = exports.LocalizationProvider = exports.getMessage = exports.getMessageCode = void 0;
const react_1 = __importStar(require("react"));
const getMessageCode = function getMessageCode(messages, code) {
    if (!messages || typeof messages !== "object")
        return undefined;
    return messages[code];
};
exports.getMessageCode = getMessageCode;
const getMessage = function getMessage(messages, code, args) {
    let message = (0, exports.getMessageCode)(messages, code);
    if (args && message) {
        for (const i in args) {
            if (Object.hasOwnProperty.call(args, i)) {
                const find = `\\{${i}\\}`;
                const re = new RegExp(find, "g");
                message = message.replace(re, `${args[i]}`);
            }
        }
    }
    return message;
};
exports.getMessage = getMessage;
const LocalizationContext = react_1.default.createContext(undefined);
function LocalizationProvider({ children, locale, messages, }) {
    return react_1.default.createElement(LocalizationContext.Provider, { value: { locale, messages } }, children);
}
exports.LocalizationProvider = LocalizationProvider;
function useLocalizationContext() {
    const context = (0, react_1.useContext)(LocalizationContext);
    if (!context) {
        throw new Error("useLocalizationContext should be used within a LocalizationProvider");
    }
    return context;
}
exports.useLocalizationContext = useLocalizationContext;
function useLocalizationMessages() {
    const context = (0, react_1.useContext)(LocalizationContext);
    if (!context) {
        throw new Error("useLocalizationMessages should be used within a LocalizationProvider");
    }
    return context.messages;
}
exports.useLocalizationMessages = useLocalizationMessages;
function useLocalizationLocale() {
    const context = (0, react_1.useContext)(LocalizationContext);
    if (!context) {
        throw new Error("useLocalizationLocale should be used within a LocalizationProvider");
    }
    return context.locale;
}
exports.useLocalizationLocale = useLocalizationLocale;
function useLocalization() {
    const messages = useLocalizationMessages();
    return react_1.default.useCallback((code, args) => (0, exports.getMessage)(messages, code, args), [messages]);
}
exports.useLocalization = useLocalization;
//# sourceMappingURL=localization.hooks.js.map